import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { TYPE_MAP } from '../../utils/editMainPageConstants';
import { CrossIcon, DeleteCrossIcon } from '../../../../../../../../assets/icons/controls/controls';
function DesktopBlocksList({
    layout,
    typeIndexByClientId,
    selectedBlockId,
    isDragging,
    onDragStart,
    onDragEnd,
    onSelectBlock,
    onOpenBlockPicker,
    onDeleteBlock,
    renderInsertBar,
    renderPreview,
    getBlockTitle,
    isEditableType,
    canEditStructure,
}) {
    return (
        <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
            <Droppable droppableId="main-page-blocks-desktop">
                {(provided) => (
                    <div
                        className={`edit-main-page__list edit-main-page__list_desktop ${isDragging ? 'edit-main-page__list_dragging' : ''}`}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {renderInsertBar(0)}
                        {layout.map((item, index) => {
                            const type = item.block?.type || item.block;
                            const canEdit = isEditableType(type);
                            const title = TYPE_MAP[type]?.title || getBlockTitle(type);
                            const isSelected = selectedBlockId === item.clientId;

                            return (
                                <Draggable key={item.clientId} draggableId={item.clientId} index={index} isDragDisabled={!canEditStructure}>
                                    {(draggableProvided) => {
                                        const dragStyle = draggableProvided.draggableProps.style;
                                        return (
                                            <div
                                                className='edit-main-page__item-stack'
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                                style={dragStyle}
                                            >
                                                <div
                                                    className={`edit-main-page__item ${isSelected ? 'edit-main-page__item_selected' : ''}`}
                                                    {...draggableProvided.dragHandleProps}
                                                    onClick={(event) => {
                                                        if (!canEdit) return;
                                                        const tag = event.target.tagName;
                                                        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'BUTTON') return;
                                                        onSelectBlock(item.clientId);
                                                    }}
                                                >
                                                    <div className='edit-main-page__item-header'>
                                                        <div className='edit-main-page__item-badge'>{index + 1}</div>
                                                        <div className='edit-main-page__item-meta'>
                                                            <p className='edit-main-page__item-title'>{title}</p>
                                                        </div>
                                                        <div className='edit-main-page__item-controls'>
                                                            {canEditStructure && <button
                                                                className='edit-main-page__item-control edit-main-page__item-control_text'
                                                                type='button'
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    onOpenBlockPicker({ mode: 'replace', targetId: item.clientId });
                                                                }}
                                                                disabled={!canEditStructure}
                                                            >
                                                                <span className='edit-main-page__item-control-text'>Изменить тип</span>
                                                            </button>
                                                            }
                                                            {canEditStructure && <button
                                                                className='edit-main-page__item-control'
                                                                type='button'
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    onDeleteBlock(index, title);
                                                                }}
                                                                disabled={!canEditStructure}
                                                            >
                                                                <CrossIcon
                                                                    mainClassName={'edit-main-page__item-control-icon'}
                                                                    strokeClassName={'edit-main-page__item-control-icon-stroke'}
                                                                />
                                                            </button>}
                                                            {canEdit ?
                                                                <button
                                                                    className='edit-main-page__item-toggle'
                                                                    type='button'
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        onSelectBlock(item.clientId);
                                                                    }}
                                                                >
                                                                    Редактировать
                                                                </button>
                                                                : null}
                                                        </div>
                                                    </div>
                                                    <div className='edit-main-page__item-preview'>
                                                        {renderPreview(item, title, isSelected)}
                                                    </div>
                                                </div>
                                                {renderInsertBar(index + 1)}
                                            </div>
                                        );
                                    }}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default DesktopBlocksList;
